const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-year',
        "label": '연도',
        "value": 'year',
        "query": {'y': 'year'},
        "options": {
          default: new Date().getFullYear()
        }
      },
      {
        component: 'search-column-keyword',
        label: '검색조건',
        value: 'column',
        query: {'ck_t': 'head', 'ck_k': 'keyword'},
        options: {
          listKey: "688_pagelist",
          hiddenList: ['작성일']
        }
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    // 검색연도
    const year = search.year || new Date().getFullYear();
    conditions.push({key: 'created_at', operator: '>=', value: `${year}-01-01`})
    conditions.push({key: 'created_at', operator: '<', value: `${year + 1}-01-01`})

    //  검색조건
    const heads = list.getHead().map(e => { return {[e.name] : e.key} });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": '학교명',
        "key": "body.stdInfo.com_name"
      },
      {
        "name": "공정명",
        "key": "body.stdInfo.공정명"
      },
      {
        "name": "공정내용",
        "key": "body.riskAppraisalList[%].사진내용"
      },
      {
        "name": "위험 기계·기구·설비",
        "key": "body.riskAppraisalList[%].input_5"
      },
      {
        "name": "재해형태",
        "key": "body.riskAppraisalList[%].input_3"
      }
    ]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 회사명
      case 1: return func.getContent(value).stdInfo.공정명 // 공정명
      case 2: return func.getContentRiskList(func.getContent(value).riskAppraisalList)// 재해형태
      case 3: return func.getContent(value).stdInfo.writer_name // 작성자
      case 4: return func.getCreatedDate(value.created_at) // 작성일
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},
}
export default list;
